export * from './ch-tabs.module';
export * from './ch-tabs.component';
